<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-2 ps-2">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0 ">My Profile</h5>
                                    </div>
                                    <div class="card-body">
                                                                              
                                        <div class="form-group " >
                                            <div class="row">
                                                <div class="col-md-3" *ngIf='roleId=="4"'>
                                                    <label for="sel1">Tenant Name : </label>
                                                    <select [(ngModel)]='tId ' (change)="changeTname()"
                                                        class="form-control form-control-sm shadow-sm rounded-lg"
                                                        id="sel1">
                                                        <option value="" [selected]="true">select</option>
                                                        <option *ngFor="let item of tenanates" [value]='item.TNT_CODE'>
                                                            {{item.TNT_NAME}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-md-3" *ngIf='isAdmin'>
                                                    <label for="sel1">User Role : </label>
                                                    <select [(ngModel)]='rId' (change)="change()"
                                                        class="form-control form-control-sm shadow-sm rounded-lg"
                                                        id="sel1">
                                                        <option value="" [selected]="true">select</option>
                                                        <option *ngFor="let item of roles" [value]='item.ROLE_ID'>
                                                            {{item.ROLE_NAME}}</option>
                                                    </select>
                                                </div>

                                            </div>


                                        </div>
                                        <div class="text-right" *ngIf='isAdmin'>
                                            <button type="button" class="btn btn-primary mb-1" [disabled]='!(+rId==2)' 
                                                (click)="add()">Add</button>
                                        </div> 
                                        <div *ngIf="table.length">
                                            <table id="patreggraph" datatable
                                                class=" table-striped table-bordered mt-2 pt-2 table-sm small"
                                                style="width:100%">
                                                <thead class="top" style="background-color: #624FD7; color:#ffffff;">
                                                    <tr>
                                                        <th> User Name </th>
                                                        <th>First Name</th>
                                                        <th> Role </th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of table">
                                                        <td>{{item.USERNAME}}</td>
                                                        <td>{{item.FIRSTNAME}}</td>
                                                        <td>{{item.ROLE_NAME}}</td>
                                                        <!-- <td>{{(rId=='2')?'Trainer':(rId=='2')?UserRoleName}}</td> -->
                                                        <td>{{item.STATUS}}</td>
                                                        <td style="display: flex;">
                                                            <span data-bs-toggle="modal" data-bs-target="#myModal"
                                                                src="" class="edit_icon" (click)="edit(item)">
                                                                <i class="fas fa-pen pt-1 mt-1"></i></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-center" *ngIf="!table.length">
                                            No Records to display
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>